<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t(titulo) }}</h1>

        <form @submit.prevent="submit" ref="addItem">
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-select
                    v-model="acompanhamento.servico_id"
                    label="Serviço"
                    grid="6"
                    :itens="servicos"
                    :required="true"
                    :loading="loadingServicos"
                    :disabled="loadingServicos"
                />
                <form-select
                    v-model="acompanhamento.tecnico_id"
                    label="Técnico de referência"
                    :required="true"
                    grid="6"
                    :itens="tecnicos"
                    :loading="loadingTecnicos"
                    :disabled="loadingTecnicos"
                />

                <form-calendar
                    v-model="acompanhamento.data_ingresso"
                    grid="3"
                    label="Data de início"
                    :required="true"
                />

                <form-calendar
                    v-model="acompanhamento.data_final"
                    grid="3"
                    label="Data Final"
                />

                <form-calendar
                    v-model="acompanhamento.data_avaliacao"
                    grid="3"
                    label="Data Avaliação"
                    :required="true"
                />

                <form-select
                    v-model="acompanhamento.periodicidade"
                    label="Periodicidade"
                    grid="3"
                    :itens="$root.arrays.acompanhamento_periodicidade"
                    :required="true"
                />

                <form-select
                    v-model="acompanhamento.pessoas"
                    :multiple="true"
                    label="Usuário(s)"
                    :itens="pessoas"
                    :required="true"
                    grid="12"
                    @change="aoAlterarPessoas"
                />

                <div
                    v-for="pessoaSituacao in pessoaSituacoes"
                    :key="pessoaSituacao.usuario_id"
                    class="col-md-12 mt-3"
                >
                    <div class="card border">
                        <div class="card-header">
                            <strong>Usuário:</strong>

                            <span
                                v-html="
                                    nomePessoa(
                                        pessoaSituacao.usuario_id
                                    )
                                "
                            />
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <form-select
                                    v-model="
                                        pessoaSituacao.vulnerabilidades
                                    "
                                    label="Vulnerabilidades"
                                    :multiple="true"
                                    :itens="vulnerabilidades"
                                    grid="12"
                                    :loading="
                                        loadingVulnerabilidades
                                    "
                                    :disabled="
                                        loadingVulnerabilidades
                                    "
                                    @change="
                                        individualizacaoAlterada = true
                                    "
                                />

                                <form-select
                                    v-model="
                                        pessoaSituacao.violencias
                                    "
                                    label="Violência/Violações de direito"
                                    :multiple="true"
                                    :itens="violencias"
                                    grid="12"
                                    :loading="loadingViolencias"
                                    :disabled="loadingViolencias"
                                    @change="
                                        individualizacaoAlterada = true
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt-4 px-0 d-flex justify-content-end">
                <form-toggle
                    grid="2"
                    class="mt-2"
                    v-model="acompanhamento.privado"
                    label="Sigilo?"
                />
                <div class="col-auto px-2 text-right ml-4">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            acompanhamento: {
                pessoas: [],
                vulnerabilidades: [],
                violencias: [],
            },
            tecnicos: [],
            tipos: [],
            servicos: [],
            files: [],
            progressCompleted: 0,
            titulo: "Iniciar Acompanhamento Familiar",
            loadingTecnicos: false,
            loadingServicos: false,
            loadingVulnerabilidades: false,
            loadingViolencias: false,
            pessoaSituacoes: [],
            individualizacaoAlterada: false,
            possuiIndividualizacao: false,
        };
    },
    mounted() {
        this.getTecnicos();
        this.getServicos();
        this.getVulnerabilidades();
        this.getViolencias();
        // this.privateFromOsasco();
    },
    computed: {
    pessoas() {
        let pessoas = this.familia.familiares;
  
        const map = pessoas.map((elem) => ({
            id: elem.id,
            searchTerms: [elem.nome_completo, elem.nome_social],
            value: elem.nome_social
            ? elem.nome_social + " <b>" + elem.idade + " ano(s)</b>"
            : elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
        }));
        return map;
    },
    },
    methods: {
        // privateFromOsasco() {
        //   const role_name = this.$store.state.user.role_details.name;
        
        //     if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'suasfacil.host'|| window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
        //         this.acompanhamento.privado =  1;
        //     } else {
        //         this.acompanhamento.privado =  2;
        //     }
        // },
        async getTecnicos() {
            this.loadingTecnicos = true;
            await axios.get(`api/dashboard/tecnicos/get`).then((response) => {
                this.tecnicos = response.data;
                this.loadingTecnicos = false;
            });
        },
        async getVulnerabilidades() {
            this.loadingVulnerabilidades = true;
            await axios
                .get(`api/dashboard/get/vulnerabilidades`)
                .then((response) => {
                    this.vulnerabilidades = response.data;
                    this.loadingVulnerabilidades = false;
                });
        },
        async getViolencias() {
            this.loadingViolencias = true;
            await axios.get(`api/dashboard/get/violencias`).then((response) => {
                this.violencias = response.data;
                this.loadingViolencias = false;
            });
        },
        async getServicos() {
            this.loadingServicos = true;
            await axios
                .get(`api/dashboard/acompanhamento/servicos`)
                .then((response) => {
                    this.servicos = response.data;
                    this.loadingServicos = false;
                });
        },
        
        submit() {
            this.acompanhamento.familia_id =
                this.$route.params.id;

            this.$route.query.familia_id =
                this.$route.params.id;

            const dados =
                this.montarPayloadIndividualizado();

            const formData =
                this.criarFormData(dados);

            const ladda = Ladda.create(
                document.querySelector(
                    ".btn-submit"
                )
            );

            ladda.start();

            axios
                .post(
                    `api/dashboard/acompanhamentos`,
                    formData
                )
                .then((response) => {
                    ladda.stop();

                    this.$snack.success({
                        button: false,
                        text:
                            "Acompanhamento cadastrado " +
                            "com sucesso.",
                    });

                    this.$router.push(
                        `/dashboard/acompanhamento/edit/` +
                            response.data.id
                    );
                })
                .catch(() => {
                    ladda.stop();
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },

        normalizarIds(valores) {
            if (
                valores === null ||
                valores === undefined ||
                valores === ""
            ) {
                return [];
            }

            if (typeof valores === "string") {
                try {
                    valores = JSON.parse(valores);
                } catch (error) {
                    valores = valores.split(",");
                }
            }

            if (!Array.isArray(valores)) {
                valores = [valores];
            }

            const ids = valores
                .map((item) => {
                    if (
                        item !== null &&
                        typeof item === "object"
                    ) {
                        return Number(item.id);
                    }

                    return Number(item);
                })
                .filter((id) => Number.isInteger(id) && id > 0);

            return [...new Set(ids)];
        },

        nomePessoa(usuarioId) {
            const pessoa = this.pessoas.find(
                (item) =>
                    Number(item.id) === Number(usuarioId)
            );

            return pessoa
                ? pessoa.value
                : `Usuário #${usuarioId}`;
        },

        aoAlterarPessoas() {
            this.sincronizarPessoasSituacoes();
            this.individualizacaoAlterada = true;
        },

        sincronizarPessoasSituacoes() {
            const usuariosSelecionados =
                this.normalizarIds(
                    this.acompanhamento.pessoas
                );

            this.pessoaSituacoes =
                usuariosSelecionados.map((usuarioId) => {
                    const existente =
                        this.pessoaSituacoes.find(
                            (item) =>
                                Number(item.usuario_id) ===
                                Number(usuarioId)
                        );

                    if (existente) {
                        return existente;
                    }

                    return {
                        usuario_id: usuarioId,
                        vulnerabilidades: [],
                        violencias: [],
                    };
                });
        },

        agruparPessoaSituacoes(registros) {
            const agrupados = {};

            registros.forEach((registro) => {
                const usuarioId = Number(
                    registro.usuario_id
                );

                if (!agrupados[usuarioId]) {
                    agrupados[usuarioId] = {
                        usuario_id: usuarioId,
                        vulnerabilidades: [],
                        violencias: [],
                    };
                }

                const situacaoId = Number(
                    registro.situacao_id
                );

                if (
                    registro.tipo ===
                    "VULNERABILIDADE"
                ) {
                    agrupados[
                        usuarioId
                    ].vulnerabilidades.push(situacaoId);
                }

                if (registro.tipo === "VIOLENCIA") {
                    agrupados[
                        usuarioId
                    ].violencias.push(situacaoId);
                }
            });

            Object.keys(agrupados).forEach(
                (usuarioId) => {
                    agrupados[
                        usuarioId
                    ].vulnerabilidades = [
                        ...new Set(
                            agrupados[
                                usuarioId
                            ].vulnerabilidades
                        ),
                    ];

                    agrupados[usuarioId].violencias = [
                        ...new Set(
                            agrupados[
                                usuarioId
                            ].violencias
                        ),
                    ];
                }
            );

            return agrupados;
        },

        montarPessoaSituacoes() {
            this.sincronizarPessoasSituacoes();

            return this.pessoaSituacoes.map(
                (item) => ({
                    usuario_id: Number(
                        item.usuario_id
                    ),

                    vulnerabilidades:
                        this.normalizarIds(
                            item.vulnerabilidades
                        ),

                    violencias: this.normalizarIds(
                        item.violencias
                    ),
                })
            );
        },

        montarPayloadIndividualizado(
            preservarDadosAntigos = false
        ) {
            const pessoaSituacoes =
                this.montarPessoaSituacoes();

            const pessoas = this.normalizarIds(
                this.acompanhamento.pessoas
            );

            const vulnerabilidades = [
                ...new Set(
                    pessoaSituacoes.reduce(
                        (resultado, item) =>
                            resultado.concat(
                                item.vulnerabilidades
                            ),
                        []
                    )
                ),
            ];

            const violencias = [
                ...new Set(
                    pessoaSituacoes.reduce(
                        (resultado, item) =>
                            resultado.concat(
                                item.violencias
                            ),
                        []
                    )
                ),
            ];

            const dados = {
                ...this.acompanhamento,
                pessoas,
                pessoa_situacoes:
                    pessoaSituacoes,
            };

            /*
            * Em registros novos, os campos gerais sempre
            * recebem a união das escolhas individuais.
            *
            * Em PAFs antigos, preserva os dados gerais
            * enquanto a individualização não for alterada.
            */
            if (
                !preservarDadosAntigos ||
                this.possuiIndividualizacao ||
                this.individualizacaoAlterada
            ) {
                dados.vulnerabilidades =
                    vulnerabilidades;

                dados.violencias = violencias;
            }

            return dados;
        },

        criarFormData(dados) {
            const formData = new FormData();

            const camposJson = [
                "pessoas",
                "vulnerabilidades",
                "violencias",
                "pessoa_situacoes",
            ];

            Object.keys(dados).forEach((key) => {
                const valor = dados[key];

                if (valor === undefined) {
                    return;
                }

                if (camposJson.includes(key)) {
                    formData.append(
                        key,
                        JSON.stringify(valor || [])
                    );

                    return;
                }

                formData.append(
                    key,
                    valor === null ? "null" : valor
                );
            });

            return formData;
        },

    },
};
</script>
